import React from 'react';
import { AuthFlow } from './AuthFlow';

const Login: React.FC = () => {
  return <AuthFlow defaultMode="signin" />;
};

export default Login;
